import { render, staticRenderFns } from "./ModalContenido.vue?vue&type=template&id=0b7cb0d6&"
import script from "./ModalContenido.vue?vue&type=script&lang=js&"
export * from "./ModalContenido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports